import React, { useRef, useState } from 'react';

const LABELS = {
  tr: { title:'Paket Tur Programı', tourInfo:'Paket Tur Bilgileri', tourName:'Tur Adı', startDate:'Başlangıç', endDate:'Bitiş', duration:'Süre', totalAmount:'Toplam Ücret', notes:'Notlar', guestName:'Misafir Adı', paxCount:'Kişi Sayısı', phone:'Telefon', hotel:'Otel / Konaklama', program:'Gezi Programı', day:'Gün', noProgram:'Program girilmemiş.', totalLabel:'Toplam Tutar', deposit:'Kapora', remaining:'Kalan', payment:'Ödeme', docNo:'Belge No', date:'Düzenleme', nights:'gece', days:'gün', persons:'kişi', print:'Yazdır / PDF', close:'Kapat' },
  en: { title:'Package Tour Program', tourInfo:'Package Tour Information', tourName:'Tour Name', startDate:'Start Date', endDate:'End Date', duration:'Duration', totalAmount:'Total Price', notes:'Notes', guestName:'Guest Name', paxCount:'Passengers', phone:'Phone', hotel:'Hotel / Accommodation', program:'Tour Program', day:'Day', noProgram:'No program entered.', totalLabel:'Total Amount', deposit:'Deposit', remaining:'Remaining', payment:'Payment', docNo:'Doc No', date:'Issued', nights:'nights', days:'days', persons:'persons', print:'Print / PDF', close:'Close' }
};

export default function PackageTourTicket({ data, onClose }) {
  const printRef = useRef();
  const [lang, setLang] = useState('tr');
  if (!data) return null;
  const { tour, days, firm } = data;
  const L = LABELS[lang];
  const fmt = (n) => '₺' + parseFloat(n||0).toLocaleString('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2});
  const fmtDate = (d) => d ? new Date(d).toLocaleDateString(lang==='tr'?'tr-TR':'en-GB') : null;
  const nights = tour.start_date && tour.end_date ? Math.round((new Date(tour.end_date) - new Date(tour.start_date)) / (1000*60*60*24)) : null;
  const logoUrl = `/api/firms/${firm?.id}/logo`;
  const fmtAmount = (amount, currency, amountTry) => currency === 'TRY' ? fmt(amountTry||amount) : `${currency} ${parseFloat(amount||0).toLocaleString('tr-TR',{minimumFractionDigits:2})}`;

  const handlePrint = () => {
    const content = printRef.current.innerHTML;
    const w = window.open('', '_blank');
    w.document.write(`<!DOCTYPE html><html lang="${lang}"><head><meta charset="utf-8"><title>Paket Tur - ${tour.name}</title><style>*{box-sizing:border-box;margin:0;padding:0;}body{font-family:Arial,sans-serif;font-size:12px;color:#222;background:#fff;}@media print{body{margin:0;}}</style></head><body>${content}</body></html>`);
    w.document.close();
    setTimeout(() => { w.print(); }, 500);
  };

  return (
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.7)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:20}}>
      <div style={{background:'var(--bg2)',borderRadius:12,maxWidth:860,width:'100%',maxHeight:'90vh',overflow:'auto',border:'1px solid var(--border)'}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'12px 16px',borderBottom:'1px solid var(--border)'}}>
          <div style={{fontSize:14,fontWeight:500}}>🧳 {L.title}</div>
          <div style={{display:'flex',gap:8}}>
            <div style={{display:'flex',border:'1px solid var(--border)',borderRadius:'var(--radius)',overflow:'hidden'}}>
              {['tr','en'].map(l=>(
                <button key={l} onClick={()=>setLang(l)}
                  style={{height:30,padding:'0 12px',border:'none',background:lang===l?'#1e3a5f':'transparent',color:lang===l?'#93c5fd':'var(--text2)',fontSize:12,cursor:'pointer',fontWeight:lang===l?500:400}}>
                  {l==='tr'?'🇹🇷 TR':'🇬🇧 EN'}
                </button>
              ))}
            </div>
            <button onClick={handlePrint} className="btn btn-sm" style={{background:'#14532d',color:'#4ade80',border:'none'}}>🖨️ {L.print}</button>
            <button onClick={onClose} className="btn btn-ghost btn-sm">{L.close}</button>
          </div>
        </div>

        <div style={{padding:20}} ref={printRef}>
          <div style={{border:'2px solid #1a1a1a',borderRadius:8,overflow:'hidden',fontFamily:'Arial,sans-serif'}}>
            <div style={{background:'#1e3a5f',color:'#fff',padding:'16px 20px',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
              <div>
                <div style={{fontSize:18,fontWeight:700}}>{firm?.name||'Turizm Acentesi'}</div>
                {firm?.phone&&<div style={{fontSize:11,opacity:0.7,marginTop:2}}>📞 {firm.phone}</div>}
              </div>
              <img src={logoUrl} alt="Logo" onError={e=>e.target.style.display='none'} style={{width:56,height:56,objectFit:'contain',borderRadius:6,background:'#fff',padding:2}}/>
            </div>

            <div style={{padding:'14px 20px',background:'#0f1117',borderBottom:'1px solid #1e2535'}}>
              <div style={{fontSize:11,fontWeight:700,color:'#475569',textTransform:'uppercase',letterSpacing:'0.05em',marginBottom:10}}>{L.tourInfo}</div>
              <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:12}}>
                {[
                  {label:L.tourName, value:tour.name},
                  {label:L.startDate, value:fmtDate(tour.start_date)||'—'},
                  {label:L.endDate, value:fmtDate(tour.end_date)||'—'},
                  {label:L.duration, value:nights?`${nights} ${L.nights} / ${nights+1} ${L.days}`:'—'},
                  {label:L.totalAmount, value:fmtAmount(tour.sale_amount, tour.sale_currency, tour.sale_amount_try)},
                  {label:L.notes, value:tour.notes||'—'},
                  ...(tour.guest_name_tour?[{label:L.guestName, value:tour.guest_name_tour}]:[]),
                  ...(tour.pax_count?[{label:L.paxCount, value:tour.pax_count+' '+L.persons}]:[]),
                  ...(tour.phone?[{label:L.phone, value:tour.phone}]:[]),
                  ...(tour.tour_hotel?[{label:L.hotel, value:tour.tour_hotel+(tour.tour_room?` — ${lang==='tr'?'Oda':'Room'}: ${tour.tour_room}`:'')}]:[]),
                ].map(item=>(
                  <div key={item.label}>
                    <div style={{fontSize:10,color:'#475569',textTransform:'uppercase',letterSpacing:'0.05em',marginBottom:2}}>{item.label}</div>
                    <div style={{fontSize:13,fontWeight:600,color:'#e2e8f0'}}>{item.value}</div>
                  </div>
                ))}
              </div>
            </div>

            <div style={{padding:'16px 20px',borderBottom:'1px solid #1e2535',background:'#0f1117'}}>
              <div style={{fontSize:11,fontWeight:700,color:'#475569',textTransform:'uppercase',letterSpacing:'0.05em',marginBottom:12}}>
                {L.program} ({days.length} {L.days})
              </div>
              {days.length===0 ? (
                <div style={{color:'#475569',fontSize:12}}>{L.noProgram}</div>
              ) : days.map(d=>(
                <div key={d.id} style={{display:'flex',gap:16,padding:'10px 0',borderBottom:'1px solid #1e2535'}}>
                  <div style={{minWidth:60,fontWeight:700,color:'#93c5fd',fontSize:13}}>{L.day} {d.day_number}</div>
                  {d.day_date&&<div style={{minWidth:100,color:'#475569',fontSize:12}}>{fmtDate(d.day_date)}</div>}
                  <div style={{flex:1,fontSize:12,color:'#e2e8f0',lineHeight:1.6}}>{d.program}</div>
                </div>
              ))}
            </div>

            <div style={{background:'#0a0d14',padding:'14px 20px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <div>
                <div style={{fontSize:10,color:'#475569',marginBottom:2}}>{L.totalLabel}</div>
                <div style={{fontSize:20,fontWeight:700,color:'#22c55e'}}>{fmtAmount(tour.sale_amount, tour.sale_currency, tour.sale_amount_try)}</div>
                {parseFloat(tour.deposit_amount||0)>0&&(
                  <div style={{marginTop:6,display:'flex',gap:16,fontSize:12}}>
                    <div><span style={{color:'#475569'}}>{L.deposit}: </span><span style={{fontWeight:600,color:'#22c55e'}}>₺{parseFloat(tour.deposit_amount).toLocaleString('tr-TR',{minimumFractionDigits:2})}</span></div>
                    <div><span style={{color:'#475569'}}>{L.remaining}: </span><span style={{fontWeight:600,color:'#ef4444'}}>₺{(parseFloat(tour.sale_amount||0)-parseFloat(tour.deposit_amount||0)).toLocaleString('tr-TR',{minimumFractionDigits:2})}</span></div>
                  </div>
                )}
              </div>
              <div style={{textAlign:'right'}}>
                <div style={{fontFamily:'monospace',fontSize:14,letterSpacing:3,color:'#334155'}}>{'|'.repeat(24)}</div>
                <div style={{fontSize:10,color:'#334155',marginTop:4}}>{L.docNo}: PKT-{String(tour.id).padStart(6,'0')}</div>
                <div style={{fontSize:10,color:'#334155'}}>{L.date}: {new Date().toLocaleDateString(lang==='tr'?'tr-TR':'en-GB')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
